module.exports = __webpack_public_path__ + "img/nextbg.6e5a88b9.png";